export default "__VITE_ASSET__C5Uj7Tgf__"